import { ALL_FILES, CLEAR_FILE, DISTRIBUTION, FILENAME, POOL } from "./UUIFormFieldsView";

export const getFileNameOptions = (usageFileNames: string[] = []) => {
    let options = usageFileNames.map((file) => ({ key: file, text: file }));
    options.unshift({ key: ALL_FILES, text: '*ALL* - Select all Files' });
    options.unshift({ key: CLEAR_FILE, text: '' });
    return options;
}

export const formatParams = (jobControls, distributionValue: string, poolValue: string, filenameValue: string [], usageFileNames: string[] = []) => {
    return jobControls.map(control => {
        if (control.ControlID === DISTRIBUTION) {
            return { ControlID: control.ControlID, CurrentValue: distributionValue }
        }
        if (control.ControlID === POOL) {
            return { ControlID: control.ControlID, CurrentValue: poolValue }
        }
        if (control.ControlID === FILENAME) {
            return { ControlID: control.ControlID, CurrentValue: filenameValue[0] === ALL_FILES ? usageFileNames.join(", ") : filenameValue.join(", ") }
        }
    })
}